import { CONTACT, mailtoHref, telHref } from "@/content/contact"
import { PageMeta } from "@/components/shared/PageMeta"
import { PAGE_SEO } from "@/lib/seo"
import { StaticPage } from "./StaticPages"

const sectionHeadingClass = "mt-10 text-balance text-lg font-semibold tracking-tight text-foreground sm:text-xl"

const linkClass = "text-primary underline-offset-4 hover:underline"

export function CondicionesPage(): React.JSX.Element {
	return (
		<>
			<PageMeta {...PAGE_SEO.condiciones} path="/condiciones" />
			<StaticPage title="Términos y condiciones de uso">
				<p>
					Cada vez que utiliza este sitio web, debe consultar las Condiciones de uso y Políticas de privacidad vigentes.
				</p>
				<p>
					En el presente documento, el nombre Biosany hace referencia a Biosany Shalósh Bayóm S.A. de C.V., Biosany.com
					o sus filiales, subsidiarias y designadas según Biosany lo considere apropiado.
				</p>
				<p>
					Biosany se reserva el derecho de realizar cambios en el sitio Web, en las Condiciones de uso y en las
					Notificaciones legales en cualquier momento. Cada vez que utiliza el sitio Web de Biosany, debe consultar las
					Condiciones de uso, Notificaciones legales y Política de privacidad vigentes en ese momento, que se aplican a
					las transacciones y al uso del sitio. Si no está satisfecho con el sitio Web de Biosany, su contenido, las
					Condiciones de uso o las Notificaciones legales, usted acepta que la única solución disponible es dejar de
					utilizar el sitio Web de Biosany.
				</p>
				<p>
					Se prohíbe utilizar el sitio indebidamente, falsear la identidad de un usuario, utilizar agentes de compra y
					llevar a cabo actividades fraudulentas en el sitio.
				</p>

				<h2 className={sectionHeadingClass}>Cláusulas de exención de responsabilidad y limitación de responsabilidad</h2>
				<p>
					Al utilizar el sitio Web de Biosany, usted acepta en forma expresa que el uso del sitio Web de Biosany se
					realiza bajo su exclusivo riesgo. El sitio Web de Biosany se proporciona &quot;tal cual está&quot; y
					&quot;como está disponible&quot;. Ni Biosany ni su empresa matriz, afiliados, subsidiarias o designadas, así
					como tampoco sus respectivos funcionarios, directores, empleados, agentes, proveedores de contenidos de
					terceros, diseñadores, contratistas, distribuidores, vendedores, patrocinadores, concedentes y demás
					(conjuntamente, &quot;Asociados&quot;) garantizan que el uso del sitio web de Biosany no sufrirá
					interrupciones ni contendrá errores. Ni Biosany ni sus Asociados garantizan la precisión ni la integridad del
					contenido ofrecido en el sitio Web de Biosany ni de los productos o servicios a la venta en el sitio. Además,
					Biosany no declara que el contenido provisto en el sitio Web de Biosany sea aplicable a, ni de uso apropiado
					en, lugares fuera de México. Biosany y sus Asociados niegan específicamente toda garantía, ya sea implícita o
					explícita, incluidas de forma no exclusiva, las garantías de título, comerciabilidad o aptitud para un
					propósito determinado. Ningún tipo de asesoramiento verbal ni información por escrito por parte de Biosany o
					sus Asociados constituirá una garantía. En algunos estados no se permiten las exclusiones o limitaciones de
					ciertas garantías, por lo que es posible que las limitaciones o exclusiones antes mencionadas no se apliquen
					en su caso.
				</p>
				<p>
					Bajo ninguna circunstancia Biosany ni sus Asociados serán responsables de ningún daño directo, indirecto,
					imprevisto, especial ni emergente que se genere, ya sea por el uso o su falta de capacidad para usar el sitio
					Web de Biosany, incluidos de forma no exclusiva, los daños que surjan a raíz de su confianza en la información
					obtenida en el sitio Web de Biosany que ocasione errores, omisiones, interrupciones, eliminación o corrupción
					de archivos, virus, demoras en la operación o transmisión, o cualquier otro tipo de error en el
					funcionamiento. La Limitación de responsabilidad precedente se aplicará en toda acción legal, ya sea por
					contrato, agravio o cualquier otro reclamo, aun cuando un representante autorizado de Biosany haya sido
					informado o debiera tener conocimiento de la posibilidad de dichos daños. Por la presente, el usuario reconoce
					que este párrafo se aplicará a todo contenido, mercadería y servicios disponibles por medio del sitio Web de
					Biosany. En algunos estados no se permiten las exclusiones o limitaciones de daños imprevistos ni emergentes,
					por lo que es posible que las limitaciones o exclusiones antes mencionadas no se apliquen en su caso.
				</p>
				<p>
					La información contenida en este sitio no está destinado a cubrir todos los usos posibles, instrucciones,
					precauciones, advertencias, interacciones, medicamentos, reacciones alérgicas, o efectos adversos. Recuerde
					que nuestros tratamientos no son medicamentos, por lo que su uso y consumo es responsabilidad de quien los
					adquiere, usa o consume.
				</p>
				<p>
					Se han hecho muchos esfuerzos para asegurar que la información que proviene de éste sitio de internet sea
					precisa, actualizada, y completa, pero no podemos garantizar sanación completa o erradicación total de su
					padecimiento. En éste entendido, la información incluida aquí puede tener nuevas recomendaciones por parte de
					nuestros especialistas de bioestimulación celular. La única intención de Biosany Shalósh Bayóm es el cuidado
					de sus pacientes y servir al consumidor que reciba nuestros servicios. Cada uno de nuestros tratamientos es
					seguro, eficaz y apropiado para cualquier paciente determinado. Sin embargo, no asumimos ninguna
					responsabilidad por cualquier deterioro en su salud. No nos hacemos responsables por cualquier información que
					provenga fuera de éste sitio de internet.
				</p>

				<h2 className={sectionHeadingClass}>Destinado a usuarios mayores de 13 años</h2>
				<p>
					El sitio Web de Biosany está destinado a personas de 13 años como mínimo. El sitio web de Biosany no está
					dirigido a niños menores de 13 años. Los usuarios que tengan menos de 13 años deben utilizar este sitio con la
					ayuda de un padre o tutor.
				</p>

				<h2 className={sectionHeadingClass}>Colores / visualización de productos</h2>
				<p>
					El sitio Web de Biosany apunta a exhibir imágenes de productos y tratamientos con la mayor precisión posible.
					No obstante, no podemos garantizar que el color que usted ve coincida con el color del producto, ya que la
					visualización del color depende, en parte, del monitor que utilice.
				</p>

				<h2 className={sectionHeadingClass}>Errores en nuestro sitio</h2>
				<p>
					Los precios y la disponibilidad de los productos y servicios están sujetos a cambios sin previo aviso. Los
					errores que se detecten serán corregidos y Biosany se reserva el derecho de revocar toda oferta indicada y
					corregir todo error, imprecisión u omisión incluso luego de la presentación de un pedido e independientemente
					de que dicho pedido se haya confirmado y cobrado. Si ya se ha cobrado la compra (tarjeta, wallet, PayPal, OXXO
					o transferencia) y el pedido se cancela, Biosany gestionará el reembolso por el mismo canal de pago utilizado,
					en la medida de lo posible. La fecha de la acreditación del importe en su cuenta dependerá de la política de
					cada banco o proveedor de pago. Las compras están sujetas a la Política de devoluciones de Biosany, que no
					admite devoluciones ni cambios de productos una vez confirmado el pedido (salvo lo previsto en la Política de
					cancelaciones).
				</p>

				<h2 className={sectionHeadingClass}>Política de precios</h2>
				<p>
					Si bien en general la variedad y los precios en Internet coinciden con los de nuestra tienda, en algunos casos
					pueden diferir. Los precios y las ofertas están sujetos a cambio.
				</p>
				<p>
					Si encuentra un precio más bajo en Biosany.com o en un Centro de Salud de Biosany del mismo producto y/o
					Tratamiento después de haber confirmado su compra, no equipararemos los precios ya que las diferencias de
					precios más bajos pueden darse a que se incluyen descuentos por cargo de envío, regalo con compra, servicios,
					financiación, paquetes de artículos, artículos gratis, errores de precios, ofertas por correo electrónico,
					artículos de cantidad limitada, temporalmente agotados, etc.
				</p>
				<p>
					Comuníquese al{" "}
					<a href={telHref} className={linkClass}>
						{CONTACT.phone}
					</a>{" "}
					para todas las transacciones de garantía de igualación de precios de Biosany.com.
				</p>

				<h2 className={sectionHeadingClass}>Política de impuestos sobre las ventas</h2>
				<p>
					Biosany cobra y paga el impuesto a las ventas según la ley de los Estados Unidos Mexicanos para transacciones
					realizadas en nuestras tiendas y a través de Biosany.com. Si usted es una entidad exenta de impuestos puede
					hacer comunicarse con uno de nuestros asesores para que lo asista en la solicitud de exención de impuestos.
					Comuníquese al{" "}
					<a href={telHref} className={linkClass}>
						{CONTACT.phone}
					</a>
					.
				</p>

				<h2 className={sectionHeadingClass}>Pago de pedidos</h2>
				<p>
					En Biosany.com puede pagar su pedido con cualquiera de los siguientes métodos, según la opción que seleccione
					durante el checkout:
				</p>
				<ul className="list-disc space-y-2 pl-5">
					<li>
						<strong>Tarjetas y wallets.</strong> Tarjetas de crédito o débito (Visa®, MasterCard®, American Express®)
						y, cuando su dispositivo y navegador lo permitan, Apple Pay o Google Pay. Estos cobros se procesan de
						forma segura a través de{" "}
						<a href="https://stripe.com" className={linkClass} rel="noopener noreferrer" target="_blank">
							Stripe
						</a>
						. Al elegir este método será redirigido al checkout de Stripe para ingresar o confirmar los datos de pago.
						Biosany no almacena la información completa de su tarjeta.
					</li>
					<li>
						<strong>PayPal.</strong> Pago con su cuenta PayPal. Será redirigido al sitio seguro de{" "}
						<a href="https://www.paypal.com" className={linkClass} rel="noopener noreferrer" target="_blank">
							PayPal
						</a>{" "}
						para autorizar el cobro. Biosany no almacena las credenciales de su cuenta PayPal.
					</li>
					<li>
						<strong>Efectivo (OXXO).</strong> Generamos un voucher de pago en efectivo mediante Stripe. Deberá
						realizar el pago en una tienda OXXO participante dentro del plazo indicado en el voucher. El pedido se
						considera pagado cuando Stripe confirme la recepción del efectivo; hasta entonces el pedido permanece
						pendiente.
					</li>
					<li>
						<strong>Transferencia bancaria (SPEI).</strong> Le mostramos los datos de nuestra cuenta y una referencia
						para que realice la transferencia por el monto exacto. El pedido permanece pendiente hasta que Biosany
						verifique y confirme el depósito. Nos reservamos el derecho de cancelar pedidos no pagados dentro del
						plazo que indiquemos o comuniquemos por correo o WhatsApp.
					</li>
				</ul>
				<p>
					El checkout en Biosany.com se realiza en varios pasos: carrito, datos de contacto y envío, y pago según el
					método elegido. Al hacer clic en &quot;Proceder al pago&quot; usted confirma los datos proporcionados y
					continúa al proveedor o instrucciones correspondientes. Recibirá confirmación por correo electrónico cuando el
					pago sea aceptado o, en el caso de transferencia bancaria, cuando Biosany valide el depósito.
				</p>
				<p>
					Si su banco, emisor de tarjeta, PayPal u OXXO rechaza o no completa el pago, el pedido no se considerará
					pagado hasta que utilice un método válido o complete el pago pendiente.
				</p>
				<p>Los cupones digitales no son acumulables.</p>

				<h2 className={sectionHeadingClass}>Cómo usar los cupones</h2>
				<p>Existen dos tipos de cupones: los cupones de regalo y los cupones permanentes.</p>
				<p>
					Los códigos de promoción que se usan en los cupones de regalo se debitan cuando se realiza el pedido. Se
					pueden canjear automáticamente por el importe total de una compra. Se los debe utilizar antes de la fecha de
					vencimiento especificada y en una sola transacción. No se los puede reponer en caso de pérdida, robo,
					eliminación o si cancela la compra. Si hubiera una reducción de precio por debajo del valor del cupón, no se
					reembolsará el valor excedente.
				</p>
				<p>
					Los cupones permanentes continúan siendo válidos después de realizarse el pedido. Se pueden canjear
					automáticamente por un porcentaje del monto total de una compra. Se los debe utilizar antes de la fecha de
					vencimiento especificada y en varias transacciones. No se los puede reponer en caso de pérdida, robo,
					eliminación o si cancela la compra.
				</p>

				<h2 className={sectionHeadingClass}>Validación de pedidos</h2>
				<p>
					Después de hacer un pedido utilizando nuestro carro de compras, comprobaremos la validez de la información
					suministrada verificando su forma de pago o dirección de envío. Nos reservamos el derecho de rechazar
					cualquier pedido o de restringir las cantidades de cualquier pedido, sin explicar los motivos. Si rechazamos
					su pedido, intentaremos notificarlo por medio de la dirección de e-mail que indicó en el pedido.
				</p>
				<p>
					Cuando rechazamos un pedido, no solemos cobrar el importe; si el cobro ya se hubiera efectuado por cualquiera
					de los métodos de pago disponibles, le gestionaremos un reembolso.
				</p>

				<h2 className={sectionHeadingClass}>Aceptación / confirmación de pedidos</h2>
				<p>
					La recepción de una confirmación del pedido, ya sea electrónica o por otro medio, no implica nuestra
					aceptación ni constituye una confirmación de nuestra oferta de venta. El sitio Web de Biosany se reserva el
					derecho de aceptar o rechazar su pedido por cualquier motivo y en cualquier momento a partir de la recepción
					del encargo.
				</p>

				<h2 className={sectionHeadingClass}>Política de cancelaciones</h2>
				<p>
					Para cancelar su compra antes del envío, deberá hacerlo dentro de las veinticuatro (24) horas siguientes a la
					fecha en que se realizó la transacción en el sitio web de Biosany. Su fecha de compra es el año, día y hora en
					que el pago quedó confirmado: en tarjetas, wallets o PayPal, al autorizarse el cobro; en efectivo OXXO, cuando
					Stripe confirme el pago del voucher; y en transferencia bancaria, cuando Biosany valide el depósito.
				</p>
				<p>
					Si la cancelación procede, el reembolso se gestionará por el mismo canal utilizado en la compra (Stripe,
					PayPal o, en el caso de transferencia SPEI, devolución a la cuenta desde la que se realizó el pago, según
					disponibilidad operativa). El plazo en que el importe se refleje en su cuenta depende de las políticas de su
					banco, emisor de tarjeta o proveedor de pago.
				</p>
				<p>
					Si usted no cancela dentro de las veinticuatro (24) horas siguientes a la fecha en que realizó su compra, su
					mercancía podrá encontrarse ya en proceso de envío y la compra ya no podrá cancelarse. En ese caso la venta se
					considera definitiva conforme a la Política de devoluciones.
				</p>
				<p>
					Usted puede cancelar los envíos mensuales y evitar nuevos cargos mensuales en cualquier momento poniéndose en
					contacto con el servicio al cliente a{" "}
					<a href={mailtoHref()} className={linkClass}>
						{CONTACT.email}
					</a>{" "}
					o al{" "}
					<a href={telHref} className={linkClass}>
						{CONTACT.phone}
					</a>{" "}
					en cualquier momento antes de la fecha de su próximo envío.
				</p>

				<h2 className={sectionHeadingClass}>Política de devoluciones</h2>
				<p>
					Por la propia seguridad de nuestros consumidores, Biosany no acepta devoluciones ni cambios de productos ni
					tratamientos. Nuestros artículos están destinados al cuidado de la salud y al consumo personal; una vez que
					salen de nuestras instalaciones no podemos garantizar las condiciones en las que pudieran ser manipulados o
					almacenados si regresaran a nuestro inventario. Esta medida evita que un producto pueda volver a circular y
					protege a todos nuestros pacientes.
				</p>
				<p>
					Puede adquirir con total tranquilidad: cada producto que le entregamos es totalmente nuevo, sin uso previo, y
					puede ingerirlo con plena confianza. La única vía para desistir de una compra antes del envío es la prevista
					en la Política de cancelaciones (dentro de las primeras veinticuatro horas).
				</p>

				<h2 className={sectionHeadingClass}>Limitación de cantidades / restricción de pedidos</h2>
				<p>
					Biosany puede, a su exclusivo criterio, limitar o cancelar las cantidades compradas por persona, por hogar o
					por pedido. Además, Biosany se reserva el derecho de rechazar todo pedido que usted realice. Son restricciones
					que pueden incluir pedidos realizados por la misma cuenta del sitio Web de Biosany, el mismo método o
					referencia de pago y pedidos con la misma dirección de envío o de facturación. Si hacemos un cambio a un
					pedido, intentaremos notificarlo utilizando la dirección de e-mail o de facturación que nos indicó al momento
					de hacer el pedido.
				</p>

				<h2 className={sectionHeadingClass}>Envíos</h2>
				<p>
					Todos los pedidos que se realizan por medio de este sitio están sujetos a la disponibilidad de productos y se
					enviarán de acuerdo con las políticas de envío de Biosany.
				</p>
				<p>
					En el caso poco probable de que su pedido nunca llegara, deberá enviar una notificación de artículos perdidos
					con la suficiente antelación para que llegue dentro de los 20 días posteriores a la recepción del mensaje de
					correo electrónico con la confirmación del envío.
				</p>

				<h2 className={sectionHeadingClass}>Impedimento de uso</h2>
				<p>
					Biosany puede, a su exclusivo criterio, dar de baja a su cuenta o impedir que utilice el sitio Web de Biosany
					en cualquier momento. Usted es personalmente responsable de todo pedido que realice o de los cargos en los que
					incurra antes de que se le cancele el uso del sitio. Biosany se reserva el derecho de cambiar, suspender o
					discontinuar todo y cualquier elemento del sitio web de Biosany en cualquier momento y sin aviso previo
				</p>

				<h2 className={sectionHeadingClass}>Procesamiento de pagos y proveedores</h2>
				<p>
					Según el método elegido, el cobro puede procesarse mediante Stripe (tarjetas, wallets y vouchers OXXO), PayPal
					o, en el caso de transferencia SPEI, mediante depósito directo a la cuenta bancaria de Biosany. Al continuar
					con el pago, usted también queda sujeto a los términos y políticas de privacidad del proveedor
					correspondiente.
				</p>
				<p>
					Cuando el método lo permita, será redirigido al entorno seguro del proveedor (por ejemplo, checkout de Stripe
					o aprobación en PayPal) para autorizar el cobro. Biosany no solicita ni almacena contraseñas de esos
					servicios, ni el número completo de su tarjeta.
				</p>
				<p>
					Una vez confirmado el pago, recibirá confirmación por correo electrónico de Biosany y, cuando el proveedor lo
					envíe, también del procesador de pagos. Si el pago no es aceptado o no se completa a tiempo (incluido el
					vencimiento de un voucher OXXO o una transferencia no identificada), la compra no se considerará pagada y
					deberá reintentar o contactar a soporte.
				</p>
				<p>
					Los reembolsos que procedan conforme a estas Condiciones (por ejemplo, cancelaciones dentro del plazo
					permitido o pedidos rechazados por Biosany) se gestionan, en la medida de lo posible, a través del mismo
					método de pago utilizado en la compra original.
				</p>
			</StaticPage>
		</>
	)
}
